<script lang="ts">
	import { page } from '$app/stores';
	import { submissionApprovalThreshold } from './shared/submissions';
	import { statusMap } from './shared/tasks';

	export let object: ObjectType;
	export let attributes = [
		'author',
		'recipient',
		'date',
		'address',
		'pageCount',
		'task',
		'latestApprovalCount',
	];
	export let layout: 'single-line' | 'multi-line' = 'single-line';
	export let displayFeedbackButton = false;
	export let project: Project = null;

	const fmt = Intl.DateTimeFormat('de-AT', {
		day: object.date && object.date.match(/^\d{4}-\d{2}-\d{2}$/) ? '2-digit' : undefined,
		month:
			object.date &&
			(object.date.match(/^\d{4}-\d{2}-\d{2}$/) || object.date.match(/^\d{4}-\d{2}$/))
				? 'long'
				: undefined,
		year: 'numeric',
	});

	const date = object.date ? fmt.format(new Date(object.date)) : null;

	const mailtoBody = `Ich habe einen Fehler in den Metadaten des folgenden Briefes gefunden:
${$page.url.href}

Fehlerbeschreibung/Verbesserungsvorschlag:

`;
</script>

<dl class="text-sm-fluid uppercase whitespace-nowrap overflow-auto no-scrollbars {layout} pt-px">
	{#if attributes.includes('author') && object.author}
		<div>
			<dt>Von</dt>
			<dd>
				<span>{object.author}</span>
				{#if layout === 'multi-line'}
					{#if object.authorGnd}
						<a
							href="https://d-nb.info/gnd/{object.authorGnd}"
							class="ring-1 ring-gray-c rounded-full px-0.5 min-w-[1rem] inline-block text-center text-xs hover:no-underline"
							target="_blank"
							rel="noreferrer"
							aria-label="GND-Eintrag von {object.author}">GND</a
						>
					{/if}
					{#if object.authorWienGeschichteWikiUrl}
						<a
							href={object.authorWienGeschichteWikiUrl}
							class="ring-1 ring-gray-c rounded-full px-0.5 min-w-[1rem] inline-block text-center text-xs hover:no-underline"
							target="_blank"
							rel="noreferrer"
							aria-label="Wien Geschichte Wiki-Seite von {object.author}">W</a
						>
					{/if}
				{/if}
			</dd>
		</div>
	{/if}
	{#if attributes.includes('recipient') && object.recipient}
		<div>
			<dt>An</dt>
			<dd>
				<span>{object.recipient}</span>
				{#if layout === 'multi-line'}
					{#if object.recipientGnd}
						<a
							href="https://d-nb.info/gnd/{object.recipientGnd}"
							class="ring-1 ring-gray-c rounded-full px-0.5 min-w-[1rem] inline-block text-center text-xs hover:no-underline"
							target="_blank"
							rel="noreferrer"
							aria-label="GND-Eintrag von {object.recipient}">GND</a
						>
					{/if}
					{#if object.recipientWienGeschichteWikiUrl}
						<a
							href={object.recipientWienGeschichteWikiUrl}
							class="ring-1 ring-gray-c rounded-full px-0.5 min-w-[1rem] inline-block text-center text-xs hover:no-underline"
							target="_blank"
							rel="noreferrer"
							aria-label="Wien Geschichte Wiki-Seite von {object.recipient}">W</a
						>
					{/if}
				{/if}
			</dd>
		</div>
	{/if}
	{#if attributes.includes('date') && date}
		<div>
			<dt>Datum</dt>
			<dd>{date}</dd>
		</div>
	{/if}
	{#if attributes.includes('address') && object.address}
		<div>
			<dt>Ort</dt>
			<dd>{object.address}</dd>
		</div>
	{/if}
	{#if attributes.includes('pageCount') && object.images}
		<div>
			<dt>Seiten</dt>
			<dd>{object.images.length}</dd>
		</div>
	{/if}

	{#if attributes.includes('task') && object.status}
		<div>
			<dt>Aufgabe</dt>
			<dd>{statusMap[object.status.toUpperCase()]}</dd>
		</div>
	{/if}
	{#if attributes.includes('latestApprovalCount') && typeof object.latestApprovalCount !== 'undefined'}
		<div>
			<dt>Bestätigungen</dt>
			<dd>{object.latestApprovalCount}/{submissionApprovalThreshold}</dd>
		</div>
	{/if}
	{#if project}
		<div>
			<dt>Projekt</dt>
			<dd>{project.title}</dd>
		</div>
	{/if}
</dl>

{#if displayFeedbackButton}
	<div class="text-sm mt-4">
		<a
			href="mailto:crowdsourcing@wienbibliothek.at?subject=Metadatenkorrektur&body={encodeURIComponent(
				mailtoBody
			)}"
			class="inline-block uppercase underline">Metadaten korrigieren</a
		>
		{#if object.link}
			<br />
			<a
				href={object.link}
				class="inline-block uppercase underline"
				target="_blank"
				rel="noreferrer">Zur digitalen Bibliothek</a
			>
		{/if}
	</div>
{/if}

<style lang="postcss">
	.single-line {
		display: flex;
		& > * + * {
			margin-left: 1.25rem;
		}
	}
	.multi-line {
		& > * + * {
			margin-top: 0.25rem;
		}
	}
</style>
